import styled from '@emotion/styled';
import {
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
} from '@gumtree/ui-library/src/base/theme';
import { Button } from '@gumtree/ui-library';

export const StyledBlockTitle = styled.div`
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.bold};
    line-height: ${lineHeights.base};
    margin-bottom: ${gutterSizes.base};
`;

export const StyledRange = styled.div`
    display: grid;
    grid-gap: ${gutterSizes.medium};
`;

export const StyledUpdateButton = styled(Button)`
    && {
        height: 38px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
